import React from 'react';
import { ViewWrapper, SinglePageWrapper, ContentWrapper } from '@/styles/index';
import Navbar from '@/components/Layout/Navbar';
// import Footer from '@/components/Layout/Footer';
import BaseCTA from '@/components/Layout/CTA';
import HeadMeta from '@/components/HeadMeta';
import ContactBanner from '@/components/Contact';
import { useSession } from 'next-auth/client';
import dynamic from 'next/dynamic';

const Footer = dynamic(() => import('@/components/Layout/Footer'));

const Contact = () => {
  const [session] = useSession();
  return (
    <ViewWrapper>
      <HeadMeta
        title="Contact – Get in touch! Pollme: Free online Poll and Micro-survey tool"
        description="Do you have any questions, feedback or suggestions? get in touch for support and sales"
      />
      <Navbar session={session} />
      <SinglePageWrapper>
        <ContactBanner />
        <ContentWrapper>
          <div className="contact-poll-wrapper">
            <iframe
              height="650px"
              width="100%"
              src="https://pollme.app/embed/aRTPKRA_hy"
              title="Pollme Contact"
              frameBorder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope"
              seamless
            />
          </div>
        </ContentWrapper>
      </SinglePageWrapper>
      <BaseCTA />
      <Footer />
    </ViewWrapper>
  );
};

export default Contact;
